<div class="container mt-2">
  <div *ngFor="let shoopingcard of shoppingcards">
    <app-card-balance [shoppingcard]="shoopingcard"></app-card-balance>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
